import { usePlanDetails } from '..';

export const PlanoNeoDetails: usePlanDetails = {
  name: 'Neo',
  basePrice: 59,
  title: 'Digital, prático e conectado como você',
  description: 'Apoio e proteção por apenas R$ 59,00 mensais',
  heroUri: 'assets/img/digital-plan-cover.webp',
  thumbnailUri: '/assets/img/digital-plan-cover.webp',
  buyButtonLabel: 'Contratar Plano Neo',
  includedDependents: {
    description:
      'Contratante (titular), cônjuge, filhos solteiros e tutelados estão incluídos no valor da mensalidade. Você ainda pode simular a adição de outros dependentes.',
    alert:
      'Caso queira adicionar outros tipos de beneficiários, você pode escolher outras opções de planos.',
  },
  benefits: [
    {
      title: 'Cobertura e assistências',
      items: [
        'Contratação individual',
        'Translado livre no estado de residência do titular',
        'Teleconsultas',
        'Orientação jurídica',
        'Acolhimento ao luto',
        'Assistência funeral',
        'Desconto em medicamentos',
        'Clube de vantagens',
      ],
    },
    {
      title: 'Beneficiários',
      description:
        'Já incluso no valor do plano, além do titular, os seguintes dependentes: cônjuge, filhos solteiros menores de 25 anos e tutelados.',
    },
    {
      title: 'Assistência funeral',
      items: [
        'Cobertura nacional',
        'Atendimento funerário 24 horas',
        'Assessoria para realização do funeral',
        'Urna com alça parreira e visor',
        'Ornamentação de urna',
        'Paramentos para cerimônia fúnebre',
        'Tanatopraxia quando em funerárias próprias',
        'Coroa de flores com faixa de homenagem',
        'Orientação do processo de Registro de Óbito',
        'Veículo para remoção',
        'Translado livre no estado de residência do titular (local do óbito até a cidade de residência e exclusivamente via terrestre)',
        'Velório online disponível nas capelas próprias',
        'Carência de 90 dias para morte natural na Região Sul',
        'Carência de 12 meses para morte natural fora da Região Sul',
        'Carência de 24 horas para morte acidental',
      ],
    },
    {
      title: 'Benefícios exclusivos nas Capelas Angelus',
      description:
        'Estruturas exclusivas para prestar as últimas homenagens de maneira digna. Estamos presentes em toda região sul com mais de 100 salas para velórios que contam com:',
      items: [
        'Equipes de apoio durante a realização do velório;',
        'Salas de descanso reservadas;',
        'Segurança e monitoramento 24h;',
        'Serviço de copa (exclusivo nas capelas Prever Angelus);',
        'Equipe de apoio durante o velório;',
        'Velório online nas unidades onde possuímos tal serviço.',
      ],
    },
    {
      title: 'Assistência Sepultamento',
      description:
        'Titular ou dependentes do plano podem optar, caso desejarem, pela cremação ou locação trienal de jazigo. Nas cidades onde a contratada não possua cemitérios e crematórios próprios ou parceiros indicados, o associado terá direito há uma cobertura de até R$ 3.000,00 (três mil reais), para locação de jazigo ou cremação. Benefício não incluído no plano. Consulte as condições para a adesão da Assistência Sepultamento.',
      items: [
        'Assistência Sepultamento individual: apenas R$15,00 adicionais na mensalidade, por dependente.',
        'Assistência Sepultamento familiar: para todos dependentes, apenas R$45,00 adicionais na mensalidade.',
      ],
    },
    // {
    //   title: 'Cremação e teleconsulta pet',
    //   description: 'Ambos os serviços por apenas R$10,00 mensais por pet.',
    //   items: [
    //     'Cuide da saúde do seu pet com veterinários para atendimento via teleconsulta.',
    //     'Finalize o ciclo do seu pet com os cuidados do Plano Prever Angelus. Atendimento para animais de até 70kg.',
    //   ],
    // },
    {
      title: 'Benefícios em vida',
      description:
        'Além da assistência funeral, você garante benefícios em vida para aproveitar melhor os dias, sem se preocupar.',
      items: [
        {
          title: 'Desconto em medicamentos',
          description:
            'Aproveite mais de 2.000 medicamentos com até 80% de desconto na rede de Farmácias credenciadas!',
        },
        {
          title: 'Clube de vantagens',
          description:
            'O Clube de vantagens Angeplus oferece para todos os associados descontos e vantagens para comprar e vender com economia. É fácil, rápido e gratuito!',
        },
      ],
    },
    {
      title: 'Acolhimento ao luto',
      items: [
        'Acompanhamento psicológico de aconselhamento e suporte que auxilia titulares e dependentes no processo do luto com 3 sessões remotas individuais e gratuitas.',
      ],
    },
    {
      title: 'Teleconsultas gratuitas',
      items: [
        'Através do APP Angeplus, em "Cuidados e Saúde" você tem acesso às teleconsultas gratuitas disponíveis para o seu plano. São mais de 30 especialidades médicas com acionamento ilimitado.',
      ],
    },
    {
      title: 'Orientação jurídica pós-óbito',
      items: [
        'Profissionais do Direito disponíveis para orientações sobre dúvidas legais relacionadas ao óbito.',
      ],
    },
  ],
};
